define('bindingHandlers/fileInputSelection',[
    'lib/knockout',
    'jquery'
], function (ko, $) {
    'use strict';

    /**
     * Returns a list of files selected using file input
     *
     * <input type="file" data-bind="fileInputSelection: doSomethingWithFilesFunction"></div>
     *
     * Parameters
     * Callback function to call when a file selection occurs. Passes a list of files selected.
     */
    ko.bindingHandlers.fileInputSelection = {
        init: function (element, valueAccessor) {
            var callback = valueAccessor(),
                $element = $(element);

            function onChange(event) {
                if (callback !== undefined && event.target.files) {
                    callback(event.target.files, event);
                }
                event.preventDefault();
                return false;
            }
            $element.on('change.fileInputSelection', onChange);


            //http://www.zyxware.com/articles/3980/solved-file-input-browse-button-requiring-double-click-in-ie10
            // IE 10 misses the first mouseDown so it does not see the click
            if (navigator && navigator.userAgent && navigator.userAgent.indexOf("MSIE 10") > 0) {
                $element.on('mousedown.fileInputSelection', function () {
                    if (!$element.parents('.disabled').length) {
                        $element.trigger('click');
                    }
                });
            }

            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                $(element).off('.fileInputSelection');
            });
        }
    };
});
